import { Button, Text } from '@telegram-apps/telegram-ui';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getMockState, subscribeToMockState } from '../helpers/backButton';
import { CommonIcon } from './CommonIcon';

const BackButtonContainer = styled.div<{ $visible: boolean }>`
  position: fixed;
  top: var(--tg-viewport-safe-area-inset-top, 0);
  left: 0;
  z-index: 9999;
  padding: 8px 12px;
  display: ${props => props.$visible ? 'flex' : 'none'};
  align-items: center;
  gap: 4px;
  pointer-events: ${props => props.$visible ? 'auto' : 'none'};
`;

const BackButtonStyled = styled(Button)`
  background: var(--tgui--section_bg_color, rgba(35, 46, 60, 0.95)) !important;
  border-radius: 60px !important;
  padding: 6px 18px 6px 12px !important;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.8;
  }
  
  &:active {
    opacity: 0.6;
  }
`;

export const MockBackButton: React.FC = () => {
  const [state, setState] = useState(() => getMockState());

  useEffect(() => {
    const updateState = () => {
      setState(getMockState());
    };
    const unsubscribe = subscribeToMockState(updateState);
    updateState();
    return unsubscribe;
  }, []);

  const handleClick = () => {
    if (state.onClickHandler) {
      state.onClickHandler();
    }
  };

  return (
    <BackButtonContainer $visible={state.visible && !!state.onClickHandler}>
      {state.visible && state.onClickHandler ? (
        <BackButtonStyled
          onClick={handleClick}
          before={<CommonIcon icon="chevron-left" type="filled" size={24} />}
        >
          <Text weight="2" style={{ fontSize: '16px' }}>
            Back
          </Text>
        </BackButtonStyled>
      ) : null}
    </BackButtonContainer>
  );
};
